import React from 'react';
export function Kids() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-372">
      <div className="max-w-[1800px] mx-auto" data-id="element-373">
        <header className="mb-20 text-center" data-id="element-374">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-375">
            The Next Generation
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-376">
            Kids
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-377">
            Playful heritage for the little ones. Traditional textiles in
            comfortable, modern cuts.
          </p>
        </header>
        <div className="flex justify-center" data-id="element-378">
          <div className="max-w-md group cursor-pointer" data-id="element-379">
            <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-6" data-id="element-380">
              <img src="https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Kids" data-id="element-381" />
            </div>
            <h3 className="text-[11px] font-display font-bold tracking-widest uppercase text-center" data-id="element-382">
              Junior Heritage Set
            </h3>
          </div>
        </div>
      </div>
    </div>;
}